<template>
  <anchor-modal
    v-model="display"
    width="600"
    :title="title"
    light
    header-color="white"
    :header-split="true"
  >
    <groups-form
      v-if="display"
      ref="form"
      @cancel="() => display = false"
      @success="successHandler"
    />
  </anchor-modal>
</template>

<script>
import GroupsForm from './GroupsForm';


export default {
  name: 'AdminGroupsModalForm',
  components: {
    GroupsForm,
  },
  data: () => ({
    display: false,
    title: '',
  }),
  methods: {
    open(group) {
      this.display = true;
      this.title = group ? 'Edit Group Permissions' : 'Add New Group';
      this.$nextTick(() => {
        this.$refs.form.setModel(group);
      });
    },
    successHandler() {
      this.$emit('success');
      this.display = false;
    },
  },
};
</script>
